import {autoserialize, autoserializeAs, inheritSerialization} from 'cerialize';
import {ModelBase} from './model-base';

@inheritSerialization(ModelBase)
export class DressCodePicture extends ModelBase {
  public static readonly type = 'DressCodePicture';
  public readonly type = DressCodePicture.type;

  @autoserialize
  public id: number;

  @autoserializeAs('file_url')
  public fileUrl: string;

  @autoserialize
  public file: string;

  @autoserialize
  public fileType: string;
}
